import { FC, useContext, useEffect, useLayoutEffect, useState, } from "react";
import { EOBsFetchFile, ShowPdfProps } from "src/pages/EOBsDetail/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";



const ViewPdf: FC<ShowPdfProps> = ({ id,onClose }): JSX.Element => {

 
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [PDF,setPDF] = useState<string>();

  useLayoutEffect(() => {
    setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { data: fetchEOBsFile ,error} =
    useFetch<EOBsFetchFile>(APIEndpoints.FETCH_EOB_FILE, {}, { id });

  useEffect(() => {
    //console.log("Fetched EOBs File Data:", fetchEOBsFile);
    if (fetchEOBsFile) {
      setPDF(fetchEOBsFile.redacted_file)
      //console.log("EOB PDF File:", fetchEOBsFile.redacted_file);
      hideLoader();
    //onClose && onClose()

    }else if(error){
      hideLoader();
      //onClose && onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchEOBsFile,error]);


  useEffect(() => {

    if (PDF) {
      // Convert Base64 to binary data
      const byteCharacters = atob(PDF);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Create a Blob and Object URL
      const blob = new Blob([byteNumbers], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
     // console.log("PDF URL:", url,"..... ",pdfUrl);
      // Cleanup function to revoke the object URL
      return () => URL.revokeObjectURL(url);
    }
  }, [PDF])

  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     if (
  //       (e.ctrlKey || e.metaKey) &&
  //       ['p', 's', 'u'].includes(e.key.toLowerCase())
  //     ) {
  //       e.preventDefault(); // Block print, save, view source
  //     }

  //     if (e.key === "Escape") {
  //       e.preventDefault(); // Block Esc key closing
  //     }

  //     // Optional: block F12
  //     if (e.key === "F12") {
  //       e.preventDefault();
  //     }
  //   };

  //   const handleContextMenu = (e: MouseEvent) => {
  //     e.preventDefault(); // Disable right-click
  //   };

  //   const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  //     e.preventDefault();
  //     e.returnValue = ''; // Required for modern browsers to show confirm dialog
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   document.addEventListener("contextmenu", handleContextMenu);
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);


  return (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          onClick={onClose} // close when clicking outside
        >
          <div
            className="modal-dialog modal-xl"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <div className="modal-content shadow">
              <div className="modal-header">
                <h3 className="modal-title">Explanation Of Benefit Form&nbsp;</h3>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                <div className="card mb-0">
                  <div className="card-body">
                    {pdfUrl ? (
                      <div className="pdf-container">
                        {/* <PdfViewer binaryString={atob(PDF || '')} /> */}
                       <iframe  title="Precert PDF" src={pdfUrl} style={{ width: "100%", height: "70vh" }}></iframe>

                      </div >
                    ) : (
                      <div>
                        <h2 className="text-center" style={{ color: "#808285" }}>
                          Form Loading, please wait...
                        </h2>
                      </div>
                    )}
                  </div>
                </div>
              </div>
               </div>
                </div>
              </div>
       
        

                    
       
  );
};

export default ViewPdf;
